import React, { useContext, useEffect } from 'react';
import { withRouter } from 'react-router-dom';
import _ from 'lodash';
import { connect } from 'react-redux';
import withForm from 'modules/common/hoc/withForm';
import Modal from 'modules/common/components/Modal';
import PropTypes from 'prop-types';
import { ModalContext } from 'App';
import * as actions from '../action';

function CreateModal({
  createInput,
  createInputNumber,
  createTransactionCode,
  formData,
  setFormData,
  getTransactionCodesList,
  history,
  getSingleTransactCode,
}) {
  const setModal = useContext(ModalContext);

  useEffect(() => {
    setFormData({
      name: '',
      code: '',
      sequence: '',
      is_active: false,
      is_land: 0,
      is_building: 0,
      is_machinery: 0,
    });
  }, []);

  const handleOnSubmit = (e) => {
    e.preventDefault();
    const args = {
      ...formData,
      name: _.get(formData, 'name').replace(/\s+/g, ' ').trim(),
    };
    createTransactionCode(args, ({ data }) => {
      setModal({ isOpen: false });
      getTransactionCodesList();
      history.push(`/rpt/settings/transaction-codes/${_.get(data, 'id')}`);
      getSingleTransactCode(data.id);
    });
  };

  const onChange = (e) => {
    return setFormData({
      ...formData,
      [e.target.name]:
        e.target.type === 'checkbox' ? e.target.checked : e.target.value,
    });
  };

  const closeModal = (e) => {
    e.preventDefault();
    setModal({ isOpen: false });
  };

  return (
    <Modal.Body>
      <form onSubmit={handleOnSubmit}>
        <div className="row">
          <div className="col-12 form-group">
            {createInput({ key: 'code', label: 'Code:' }, { required: true })}
          </div>
          <div className="col-12 form-group">
            {createInput(
              { key: 'name', label: 'Description:' },
              { required: true, type: 'text' }
            )}
          </div>
          <div className="col-12 form-group">
            {createInputNumber(
              { key: 'sequence', label: 'Sequence:' },
              { required: true }
            )}
          </div>
          <div className="col-12 form-group">
            <label htmlFor="last_name" className="form-label">
              Kind/s
            </label>
          </div>
          <div className="col-4 form-group">
            <input
              name="is_land"
              type="checkbox"
              checked={_.get(formData, 'is_land')}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label">
              &nbsp; Land
            </label>
          </div>
          <div className="col-4 form-group">
            <input
              name="is_building"
              type="checkbox"
              checked={_.get(formData, 'is_building')}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label">
              &nbsp; Building
            </label>
          </div>
          <div className="col-4 form-group">
            <input
              name="is_machinery"
              type="checkbox"
              checked={_.get(formData, 'is_machinery')}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label">
              &nbsp; Machinery
            </label>
          </div>
          <div className="col-12 form-group">
            <input
              name="is_active"
              type="checkbox"
              checked={_.get(formData, 'is_active')}
              onChange={onChange}
            />
            <label htmlFor="last_name" className="form-label">
              &nbsp; Is Active
            </label>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <button
            type="submit"
            className="mt-3 btn btn-primary cms-bg-color-primary cms-outline-primary  mr-3"
          >
            <span className="font-weight-bold">Submit</span>
          </button>
          <button
            type="button"
            onClick={closeModal}
            className="mt-3 btn btn-dark "
          >
            <span className="font-weight-bold">Cancel</span>
          </button>
        </div>
      </form>
    </Modal.Body>
  );
}

CreateModal.propTypes = {
  createInput: PropTypes.instanceOf(Function).isRequired,
  createInputNumber: PropTypes.instanceOf(Function).isRequired,
  getTransactionCodesList: PropTypes.instanceOf(Function).isRequired,
  createTransactionCode: PropTypes.instanceOf(Function).isRequired,
  setFormData: PropTypes.instanceOf(Function).isRequired,
  formData: PropTypes.instanceOf(Object).isRequired,
  history: PropTypes.instanceOf(Object).isRequired,
  getSingleTransactCode: PropTypes.instanceOf(Function).isRequired,
};

const mapStateToProps = () => ({});

const enhance = _.flowRight([
  withForm,
  withRouter,
  connect(mapStateToProps, {
    ...actions,
  }),
]);

export default enhance(CreateModal);
